var _g, _circle, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup47220(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 214,
    height: 214,
    viewBox: "0 0 214 214",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_8945_325)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 107,
    cy: 107,
    r: 107,
    fill: "#D6EBFA"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8945_325",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 214,
    height: 214
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 107,
    cy: 107,
    r: 107,
    fill: "#C3EEFF"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8945_325)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_8945_325)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 113.411,
    cy: 54.3406,
    rx: 125.858,
    ry: 104.13,
    fill: "#C5EAFF"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_8945_325)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 213.948,
    cy: -8.37534,
    rx: 125.858,
    ry: 104.13,
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_8945_325)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M101.495 5.50561C33.2732 29.9217 17.4745 72.5302 17.4745 151.045C-26.0201 151.045 -56.0132 51.9086 -56.0132 5.50561C-56.0132 -40.8974 -20.7539 -78.5145 22.7407 -78.5145C66.2353 -78.5145 101.495 -40.8974 101.495 5.50561Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_8945_325",
    x: -7.65996,
    y: -5.74497,
    width: 221.66,
    height: 219.745,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -7.65996,
    dy: -5.74497
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10.5324
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_8945_325"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_8945_325",
    x: -90.9621,
    y: -128.304,
    width: 408.746,
    height: 365.29,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 39.2573,
    result: "effect1_foregroundBlur_8945_325"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_8945_325",
    x: 9.57505,
    y: -191.02,
    width: 408.746,
    height: 365.29,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 39.2573,
    result: "effect1_foregroundBlur_8945_325"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_8945_325",
    x: -92.398,
    y: -114.899,
    width: 230.277,
    height: 302.329,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 18.1924,
    result: "effect1_foregroundBlur_8945_325"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup47220);
export default __webpack_public_path__ + "static/media/Group 47220.29c6a1240f1115646e44baa52b754e31.svg";
export { ForwardRef as ReactComponent };